/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_3_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The next person can open, inspect and continue editing the right file.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一位使用者可以打开、检查并继续编辑正确的文件。`)
};

/**
* | output |
* | --- |
* | "The next person can open, inspect and continue editing the right file." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_3_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_3_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_3_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_3_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_3_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_3_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_3_1 as "gc.search_guides.gridcraft_vs_excel.sections.5.table.rows.3.1" }